<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaAperturaDesde="fechaAperturaDesdeParam"
          :fechaAperturaHasta="fechaAperturaHastaParam"
          :incluirAbiertas="incluirAbiertas"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Cajas">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="cajasRegistros" 
              :fields="cajasRegistrosFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <!--
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            -->
            <template v-slot:cell(fechaApertura)="data">
              {{ data.item.fechaApertura | fechaHora }}
            </template>
            <template v-slot:cell(fechaCierre)="data">
              {{ data.item.fechaCierre | fechaHora }}
            </template>
            <template v-slot:cell(saldoPesos)="data">
              {{ data.item.saldoPesos | moneda }}
            </template>
            <template v-slot:cell(saldoChequesTerceros)="data">
              {{ data.item.saldoChequesTerceros | moneda }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="consultarMovimientos(data.item)">
                  <i class="fa fa-info"></i>Consultar Movimientos</b-dropdown-item>
                <b-dropdown-item 
                    v-if="!data.item.cerrada"
                    @click.stop="ajusteCaja(data.item)">
                  <i class="fa fa-plus"></i>Ajuste de Caja</b-dropdown-item>
                <b-dropdown-item 
                    v-if="!data.item.cerrada"
                    @click.stop="cerrar(data.item)">
                  <i class="fa fa-remove"></i>Cerrar Caja</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="showApertura">
            <i class="fa fa-plus"></i>Abrir Nueva Caja</b-dropdown-item>
          <b-dropdown-item @click.stop="transferir">
            <i class="fa fa-exchange"></i>Nueva Transferencia Entre Cajas</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="aperturaModal" 
        title="Abrir Caja"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-apertura-caja
        @updateCajasRegistros="updateCajasRegistros"
        @closeApertura="closeApertura">
      </app-apertura-caja>  
    </b-modal>

    <b-modal ref="cierreModal" 
        title="Cerrar Caja"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-caja-cierre
        :cajaRegistroId="cajaRegistroId"
        @close="closeCierre">
      </app-caja-cierre>  
    </b-modal>

    <b-modal ref="transferenciaModal" 
        title="Nueva Transferencia Entre Cajas"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-transferencia
        @close="closeTransferencias">
      </app-transferencia>  
    </b-modal>

    <b-modal ref="ajusteModal" 
        title="Ajuste de Caja"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-ajuste
        :cajaRegistroId="cajaRegistroId"
        @close="closeAjuste">
      </app-ajuste>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import AperturaCaja from './ABM.vue';
import CajaCierre from './CajaCierre.vue';
import Transferencia from './Transferencia.vue';
import Ajuste from './Ajuste.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'cajasregistros/getField',
  mutationType: 'cajasregistros/updateField',
});

export default {
  name: 'CajasRegistros',
  components: {
    appFiltro: Filtro,
    appAperturaCaja: AperturaCaja,
    appCajaCierre: CajaCierre,
    appTransferencia: Transferencia,
    appAjuste: Ajuste,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      cajasRegistrosFields: [
        { 
          key: 'id',
          label: 'Nro Caja',
          class: 'text-right'
        },
        { key: 'nombre' },
        {
          key: 'fechaApertura',
          label: 'Fecha Apertura'
        },
        {
          key: 'fechaCierre',
          label: 'Fecha Cierre'
        },
        {
          key: 'saldoPesos',
          class: 'text-right'
        },
        {
          key: 'saldoChequesTerceros',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      cajaRegistroId: 0,
      cajaRegistroSeleccionada: null,
    }
  },
  computed: {
    ...mapFields([
      'cajasRegistros',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaAperturaDesde',
      'fechaAperturaHasta',
      'incluirAbiertas'
    ]),
    fechaAperturaDesdeParam() {
      return moment(this.fechaAperturaDesde).format('YYYY-MM-DD');
    },
    fechaAperturaHastaParam() {
      return moment(this.fechaAperturaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaAperturaDesde = filtro.fechaAperturaDesde;
      this.fechaAperturaHasta = filtro.fechaAperturaHasta;
      this.incluirAbiertas = filtro.incluirAbiertas;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('cajasregistros/getCajasRegistros')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    consultarMovimientos(item) {
      this.$router.push({ name: 'CajaRegistroMovimientos', 
                          params: { id: item.id }});
    },
    cerrar(item) {
      this.cajaRegistroId = item.id;
      this.$refs.cierreModal.show();
    },
    closeCierre(cajaCerrada) {
      this.$refs.cierreModal.hide();
      if (cajaCerrada) {
        this.getItems();  
      }
    },
    showApertura() {
      this.$refs.aperturaModal.show();
    },   
    updateCajasRegistros() {
      this.$refs.aperturaModal.hide();
      this.getItems();
    },
    closeApertura() {
      this.$refs.aperturaModal.hide();
    },
    transferir() {
      this.$refs.transferenciaModal.show();
    },
    closeTransferencias(transferenciaRegistrada) {
      this.$refs.transferenciaModal.hide();
      if (transferenciaRegistrada) {
        this.getItems();
      }
    },
    ajusteCaja(item) {
      this.cajaRegistroId = item.id;
      this.$refs.ajusteModal.show();
    },
    closeAjuste(ajusteRealizado) {
      this.$refs.ajusteModal.hide();
      if (ajusteRealizado) {
        this.getItems();  
      }
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
